import { Tooltip } from "antd";
import styled from "styled-components";
import React from "react";

export default function TooltipInfo({ title, children }) {
  return (
    <Tooltip placement="top" title={title}>
      <div
        className="mr-2"
        style={{
          border: "1px solid #F4F4F4",
          borderRadius: 20,
        }}
      >
        <BadgeStyled>{children}</BadgeStyled>
      </div>
    </Tooltip>
  );
}

const BadgeStyled = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #212529;
  background: #e0e0e0;
  border-radius: 20px;
  border: 1px solid #fff;
  text-align: center;
  padding: 3px 10px;
  &:hover {
    background: #fafafa;
  }
`;
